export enum FileUploadStatusEnum {
  notStarted,
  inProgress,
  complete,
  error
}